import { FormikProps } from 'formik';
import { ChangeEventHandler } from 'react';

import styles from './SliderInput.module.css';

export interface SliderInputProps<T> {
  formikProps: FormikProps<T>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  valueKey: keyof T;
  value?: string;
  disabled: boolean;
  rangeLabels: string[];
  label?: JSX.Element;
  step?: string | undefined;
  min?: string;
  max?: string;
}

export function SliderInput<T>({
  formikProps,
  onChange,
  valueKey,
  value,
  disabled,
  rangeLabels,
  label,
  step,
  min = '0',
  max = '100',
}: SliderInputProps<T>) {
  const sliderValue = value || `${Number(formikProps.values[valueKey])}`;
  return (
    <div className={styles['container']}>
      <div className={styles['label']}>{label}</div>
      <div className={styles['slider-container']}>
        <span
          className={styles['slider-fill']}
          style={{
            width: `${sliderValue}%`,
          }}
        />
        <span
          className={styles['slider-knob']}
          style={{
            left: `calc(${sliderValue}%)`,
          }}
        >
          <span />
        </span>
        <input
          disabled={disabled}
          type="range"
          min={min}
          max={max}
          step={step}
          value={sliderValue}
          onChange={onChange || formikProps.handleChange(valueKey)}
          className={styles['hidden-slider']}
        />
      </div>
      <div className={styles['labels-grid']}>
        {rangeLabels.map((rangeLabel, index) => {
          return (
            <p key={index} className={styles['label']}>
              {rangeLabel}
            </p>
          );
        })}
      </div>
    </div>
  );
}
